import { type FrameVariant } from '@packages/surveys-widget-common/src/api'

export type ParentMessageData = { frameId: string } & (
  | { type: 'specific.widget.set-height'; height: number }
  | { type: 'specific.widget.first-touch' }
  | { type: 'specific.widget.closed' }
  | { type: 'specific.widget.mounted' }
  | { type: 'specific.widget.input-focus' }
  | { type: 'specific.widget.input-blur' }
  | { type: 'specific.widget.config'; variant: FrameVariant }
)

export const postMessageToParent = (data: ParentMessageData) => {
  window.parent.postMessage(data, '*')
}
